module.exports = __webpack_public_path__ + "static/img/partner-ss.cd7fa36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-ss.png
// module id = 1tF3
// module chunks = 34